<template>
  <div>
    <h3>Information Updates</h3>

    <b-input-group class="filter-group">
      <b-input-group-prepend is-text>
        <font-awesome-icon icon="search" />
      </b-input-group-prepend>
      <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
      <b-input-group-append>
        <b-button @click="filter = null">Clear</b-button>
      </b-input-group-append>
    </b-input-group>

    <b-tabs>
      <b-tab title="Incomplete" active>
        <information-updates-list :informationUpdates="incompleteUpdates" :completed="false" class="my-2"></information-updates-list>
      </b-tab>
      <b-tab title="Completed">
        <information-updates-list :informationUpdates="completedUpdates" :completed="true" class="my-2"></information-updates-list>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import InformationUpdatesList from "@/components/opportunities/information-updates-list";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      filter: null
    };
  },

  components: {
    "information-updates-list": InformationUpdatesList
  },

  computed: {
    ...mapState("informationUpdates", ["incompleteUpdates", "completedUpdates"])
  },

  methods: {
    ...mapActions("informationUpdates", ["getUpdates"])
  },

  created() {
    this.getUpdates();
  }
};
</script>

<style scoped>
.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
}
</style>
